module.exports = __webpack_public_path__ + "img/Painting01.b844421c.png";